export default "__VITE_ASSET__BgPdoKEk__"